import { SubbodyText as StyledSubbodyText } from './SubbodyText.styles';
import * as React from 'react';

export interface SubbodyTextProps {
  /**
   * Subbody text contents.
   */
  label: string;
  /**
   * If true, text will be grey.
   */
  grey?: boolean;
}

/**
 * The minor text contents of the page.
 */
export const SubbodyText: React.FC<SubbodyTextProps> = ({
  grey = false,
  label,
  ...props
}: SubbodyTextProps) => {
  return (
    <StyledSubbodyText grey={grey} {...props}>
      {label}
    </StyledSubbodyText>
  );
};

export default SubbodyText;
